require('./../../vendor/imi/promo-base/src/resources/js/bootstrap.js');
require('./../../vendor/imi/loyalty-module/src/resources/js/bonuses-select-validation.js');

$('#flashesModal').modal('show');
$('#surveyModal').modal('show');
